function setCityCookie(city) {
    document.cookie = "userCity=" + city + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
}

function getCityCookie() {
    var name = "userCity=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}


if (Shopify.designMode) {
    setCityCookie('Bangalore');
}

function isCityCookieSet() {
    return document.cookie.split(';').some((cookie) => cookie.trim().startsWith('userCity='));
}

function getCookie(name) {
    if(Shopify.designMode) {
        return "Bangalore"
    }

// Split cookie string and get all individual name=value pairs in an array
let cookieArr = document.cookie.split(";");

// Loop through the array elements
for(let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if(name == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
    }
}

// Return null if not found
return null;
}

if(window.location.pathname.includes('delhi') && !isCityCookieSet() && !Shopify.designMode) {
    setCityCookie("Delhi");
} else if(window.location.pathname.includes('mumbai') && !isCityCookieSet() && !Shopify.designMode) {
    setCityCookie("Mumbai");
} else if(window.location.pathname.includes('hyderabad') && !isCityCookieSet() && !Shopify.designMode) {
    setCityCookie("Hyderabad");
} else if(!isCityCookieSet() && !Shopify.designMode) {
    setCityCookie("Bangalore");
}

// Shopflo: intercept cart icon clicks
// FIX (19-Aug-2026): persist delivery details / Personal Message as cart attributes
// before showing the Shopflo cart, so order-level attributes are always up to date.
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('[aria-controls="cart-drawer"]');
  if (!trigger) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (typeof window.saveDeliveryDetailsToCart === 'function') {
    window.saveDeliveryDetailsToCart().finally(function() {
      if (typeof handleFloCartBtn === 'function') handleFloCartBtn();
    });
  } else if (typeof handleFloCartBtn === 'function') {
    handleFloCartBtn();
  }
}, true);

// Shopflo: intercept buy-now
// Save delivery details before Shopflo starts checkout.

document.addEventListener('click', function(e) {

  var btn =
    e.target.closest('#flo-buy-now-button');

  if (!btn) {
    return;
  }

  e.preventDefault();
  e.stopImmediatePropagation();

  console.log(
    'Shopflo Buy Now clicked - saving delivery details first'
  );

  /* -----------------------------------------
     SAVE DELIVERY DETAILS
  ----------------------------------------- */

  if (
    typeof window.saveDeliveryDetailsToCart ===
    'function'
  ) {

    window.saveDeliveryDetailsToCart()

      .then(function() {

        console.log(
          'Delivery details saved. Continuing to Shopflo.'
        );

        /* -----------------------------------------
           CONTINUE WITH SHOPFLO
        ----------------------------------------- */

        if (
          typeof handleFloBuyNowBtn ===
          'function'
        ) {

          handleFloBuyNowBtn(e);

        } else {

          console.error(
            'Shopflo handleFloBuyNowBtn function not found.'
          );

        }

      })

      .catch(function(error) {

        console.error(
          'Buy Now stopped because delivery details could not be saved.',
          error
        );

      });

  } else {

    console.warn(
      'saveDeliveryDetailsToCart() is not available. Continuing with Shopflo.'
    );

    if (
      typeof handleFloBuyNowBtn ===
      'function'
    ) {

      handleFloBuyNowBtn(e);

    }

  }

}, true);

// Shopflo: intercept checkout button clicks
// FIX (19-Aug-2026): persist delivery details / Personal Message as cart attributes
// before proceeding to Shopflo checkout.
document.addEventListener('click', function(e) {
  var btn = e.target.closest('#checkout2');
  if (!btn) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (typeof window.saveDeliveryDetailsToCart === 'function') {
    window.saveDeliveryDetailsToCart().finally(function() {
      if (typeof handleFloCheckoutBtn === 'function') handleFloCheckoutBtn();
    });
  } else if (typeof handleFloCheckoutBtn === 'function') {
    handleFloCheckoutBtn();
  }
}, true);

// Shopflo: intercept cart-drawer open/show to show Shopflo cart instead
customElements.whenDefined('cart-drawer').then(function() {
  var CartDrawerClass = customElements.get('cart-drawer');
  if (!CartDrawerClass) return;

  var methodNames = ['open', 'show'];
  methodNames.forEach(function(method) {
    if (typeof CartDrawerClass.prototype[method] === 'function') {
      var original = CartDrawerClass.prototype[method];
      CartDrawerClass.prototype[method] = function() {
        if (typeof handleFloCartBtn === 'function') { handleFloCartBtn(); return; }
        return original.apply(this, arguments);
      };
    }
  });
});

/* =====================================
   GLOBAL CITY SELECTOR
   FIX (19-Aug-2026): the city popup and its click/redirect wiring used
   to live only in custom-product.js, which loads on product pages only.
   Once city selection started redirecting to city-specific landing
   pages, users landed on pages with no popup logic at all - the header
   button looked clickable but did nothing there. Popup markup + this
   wiring now render/run site-wide so the selector always works,
   regardless of what page a city change lands you on. Delivery
   date/slot rendering itself stays in custom-product.js, scoped to
   PDPs, and reads the shared state exposed here (window.cityDeliveryConfig,
   window.currentCityId).
===================================== */

document.addEventListener('DOMContentLoaded', function () {

    window.cityDeliveryConfig = {};

    (function () {

        var configEl = document.getElementById('city-delivery-config');

        if (!configEl) {
            return;
        }

        try {
            window.cityDeliveryConfig = JSON.parse(configEl.textContent) || {};

            /* FIX (20-Aug-2026): metaobject list order isn't guaranteed to
               be chronological, so slots could render in an arbitrary
               sequence that has nothing to do with time of day - and since
               updateSlotStatus() only toggles classes and never reorders
               the DOM, a slot could appear to "jump" position once it
               closes, when really the whole list was never sorted to
               begin with. Sort each city's slots by cutoff time once here
               so the displayed order is always fixed and chronological. */
            Object.keys(window.cityDeliveryConfig).forEach(function (cityId) {
                var cityData = window.cityDeliveryConfig[cityId];
                if (cityData && cityData.slots) {
                    cityData.slots.sort(function (a, b) {
                        return a.cutoff.localeCompare(b.cutoff);
                    });
                }
            });
        } catch (error) {
            console.error('Failed to parse city-delivery-config:', error);
        }

    })();

    window.currentCityId = null;

    var cityLandingUrls = {
        bangalore: '/',
        delhi: '/pages/flower-delivery-delhi',
        hyderabad: '/pages/flower-delivery-hyderabad'
    };

    var popup = document.getElementById('location-popup');
    var changeLocationBtn = document.getElementById('change-location-btn');
    var headerCityTrigger = document.getElementById('header-city-trigger');
    var stickyCityTrigger = document.getElementById('sticky-city-trigger');
    var closePopup = document.querySelector('.close-popup');

    var cityOptions = document.querySelectorAll('.city-option');

    var selectedCity = document.getElementById('selected-city');
    var selectedAddress = document.getElementById('selected-address');
    var headerSelectedCity = document.getElementById('header-selected-city');
    var stickySelectedCity = document.getElementById('sticky-selected-city');

    function openLocationPopup() {
        if (popup) {
            popup.classList.add('active');
        }
    }

    function closeLocationPopup() {
        if (popup) {
            popup.classList.remove('active');
        }
    }

    if (changeLocationBtn) {
        changeLocationBtn.addEventListener('click', openLocationPopup);
    }

    if (headerCityTrigger) {
        headerCityTrigger.addEventListener('click', openLocationPopup);
    }

    if (stickyCityTrigger) {
        stickyCityTrigger.addEventListener('click', openLocationPopup);
    }

    if (closePopup) {
        closePopup.addEventListener('click', closeLocationPopup);
    }

    function selectCity(cityId) {

        if (!window.cityDeliveryConfig[cityId]) {
            console.warn('Unknown city id, ignoring:', cityId);
            return;
        }

        var previousCityId = window.currentCityId;

        window.currentCityId = cityId;

        var cityName = window.cityDeliveryConfig[cityId].cityName;

        if (selectedCity) {
            selectedCity.textContent = cityName;
        }

        if (selectedAddress) {
            selectedAddress.textContent = cityName + ', India';
        }

        if (headerSelectedCity) {
            headerSelectedCity.textContent = cityName;
        }

        if (stickySelectedCity) {
            stickySelectedCity.textContent = cityName;
        }

        localStorage.setItem('selectedCityId', cityId);

        /* FIX (20-Aug-2026): theme.js has its own, older city-filtering
           system for product cards and nav menu items (ProductCard's
           constructor and the header's primaryNavItems loop), both keyed
           off getCookie_fn('userCity') - a cookie this new selector never
           touched. Without this, switching city here updated the header/
           dates/slots but left the actual product listing and nav menu
           stuck on whatever city was cookied on a much earlier visit.
           Keep that legacy cookie in sync so everything matches. */
        setCityCookie(cityName);

        console.log('Delivery city updated:', cityName);

        /* Only redirect on an actual user-initiated change, never on the
           initial city load from localStorage - previousCityId is null then. */
        if (previousCityId && previousCityId !== cityId && cityLandingUrls[cityId]) {

            var redirectUrl = cityLandingUrls[cityId];

            /* Preserve the current query string (e.g. preview_theme_id while
               testing, or UTM params for real traffic) instead of dropping it. */
            if (window.location.search) {
                redirectUrl += window.location.search;
            }

            window.location.href = redirectUrl;
            return;
        }

        if (typeof window.saveDeliveryDetailsToCart === 'function') {
            window.saveDeliveryDetailsToCart();
        }

    }

    window.selectCity = selectCity;

    cityOptions.forEach(function (option) {

        option.addEventListener('click', function () {

            var cityId = this.dataset.cityId;

            closeLocationPopup();

            selectCity(cityId);

        });

    });

    (function initializeCity() {

        var availableCityIds = Object.keys(window.cityDeliveryConfig);

        if (availableCityIds.length === 0) {
            console.warn('No active cities found in city-delivery-config.');
            return;
        }

        var savedCityId = localStorage.getItem('selectedCityId');

        var initialCityId;

        if (savedCityId && window.cityDeliveryConfig[savedCityId]) {
            initialCityId = savedCityId;
        } else if (window.cityDeliveryConfig.bangalore) {
            initialCityId = 'bangalore';
        } else {
            initialCityId = availableCityIds[0];
        }

        selectCity(initialCityId);

    })();

});
